"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var styles = {
  "skip-link": "skip-link_3Dg0P3",
  "skipLink": "skip-link_3Dg0P3"
}; 
require('./SkipLink.css');
var SkipLink = function SkipLink(_ref) {
  var children = _ref.children,
    id = _ref.id;
  var element = global.document.getElementById(id);
  if (!element) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _classnames.default)(styles.skipLink, 'visually-hidden', 'show-on-focus'),
    onFocus: function onFocus() {
      element.classList.add('force-outline');
    },
    onBlur: function onBlur() {
      element.classList.remove('force-outline');
    },
    href: "".concat(global.location.href.split('#')[0], "#").concat(id)
  }, children);
};
var _default = exports.default = SkipLink;
//# sourceMappingURL=SkipLink.js.map